module.exports = __webpack_public_path__ + "img/logo.0a549d43.png";